<div class="flex-row">
    <div>
        <sidebar-menu>
            <div class="sidebar-title">
                <hr />
                <div>Food</div>
            </div>

            <hr class="sidebar-hr" />

            <div class="sidebar-body">
                <div class="sidebar-block-link">
                    <a [ngClass]="{'active': activeMenu === menuEnum.Restaurants}"
                       (click)="clickMenu(menuEnum.Restaurants)">Restaurants</a>
                </div>
                <div class="sidebar-block-link">
                    <a [ngClass]="{'active': activeMenu === menuEnum.Categories}"
                       (click)="clickMenu(menuEnum.Categories)">Categories</a>
                </div>
                <div class="sidebar-block-link">
                    <a [ngClass]="{'active': activeMenu === menuEnum.Modifiers}"
                       (click)="clickMenu(menuEnum.Modifiers)">Modifiers</a>
                </div>
                <div class="sidebar-block-link">
                    <a [ngClass]="{'active': activeMenu === menuEnum.ModifierGroups}"
                       (click)="clickMenu(menuEnum.ModifierGroups)">Modifier Groups</a>
                </div>
                <div class="sidebar-block-link">
                    <a [ngClass]="{'active': activeMenu === menuEnum.Products}"
                       (click)="clickMenu(menuEnum.Products)">Products</a>
                </div>
            </div>
        </sidebar-menu>
    </div>
    <!-- width: calc(100vw - 410px);  -->
    <div class="sidebar-next-right-block">
        <xpress-topbar style="width: 100vw; display: block; margin-bottom: 20px;"></xpress-topbar>

        <food-restaurants *ngIf="activeMenu === menuEnum.Restaurants"></food-restaurants>
        <food-categories *ngIf="activeMenu === menuEnum.Categories"></food-categories>
        <food-modifiers *ngIf="activeMenu === menuEnum.Modifiers"></food-modifiers>
        <food-modifier-groups *ngIf="activeMenu === menuEnum.ModifierGroups"></food-modifier-groups>
        <food-products *ngIf="activeMenu === menuEnum.Products"></food-products>
    </div>
</div>
